"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.includes.js");
var _utils = require("../utils");
var _event = require("../utils/event");
var _popup = require("../mixins/popup");
var _icon = _interopRequireDefault(require("../icon"));
var _loading = _interopRequireDefault(require("../loading"));
var _swipeNew = _interopRequireDefault(require("../swipe-new"));
var _swipeItemNew = _interopRequireDefault(require("../swipe-item-new"));
var _bizVideo = _interopRequireDefault(require("../biz-video"));
var _rate = _interopRequireDefault(require("../rate"));
var _iphoneX = require("../mixins/iphone-x");
var _zzUtils = require("@zz-common/zz-utils");
/* eslint-disable no-unneeded-ternary */
/* eslint-disable prefer-destructuring */

var _use = (0, _utils.use)('image-preview'),
  sfc = _use[0],
  bem = _use[1];
var MAX_ZOOM = 3;
var MIN_ZOOM = 1 / 3;

// 双指手势操作
function getDistance(event) {
  var touches = event.touches;
  return Math.sqrt(Math.abs((touches[0].clientX - touches[1].clientX) * (touches[0].clientY - touches[1].clientY)));
}
var _default2 = sfc({
  mixins: [_popup.PopupMixin, _iphoneX.iPhoneXMixin],
  props: {
    images: Array,
    texts: Array,
    expandTexts: Array,
    className: null,
    lazyLoad: Boolean,
    showClose: Boolean,
    asyncClose: Boolean,
    showLoading: Boolean,
    startPosition: Number,
    showIndicators: Boolean,
    loop: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    goodsInfo: {
      type: Object,
      default: function _default() {}
    },
    overlayClass: {
      type: String,
      default: 'z-image-preview__overlay'
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    adaptHeight: {
      type: Boolean,
      default: false
    },
    loadingType: {
      type: String,
      default: 'spinner'
    },
    onChangeItem: Function,
    onError: Function,
    onClickComment: Function,
    onClickPrise: Function
  },
  data: function data() {
    return {
      scale: 1,
      moveX: 0,
      moveY: 0,
      moving: false,
      zooming: false,
      active: 0,
      doubleClickTimer: null,
      loaded: {},
      isTouch: false
    };
  },
  computed: {
    imageStyle: function imageStyle() {
      var scale = this.scale;
      var style = {
        transition: this.zooming || this.moving ? '' : '.3s all'
      };
      if (scale !== 1) {
        style.transform = "scale3d(" + scale + ", " + scale + ", 1) translate(" + this.moveX / scale + "px, " + this.moveY / scale + "px)";
      }
      return style;
    }
  },
  watch: {
    value: function value() {
      this.active = Math.min(this.startPosition, this.images.length - 1);
    },
    startPosition: function startPosition(val) {
      this.active = Math.min(val, this.images.length - 1);
    }
  },
  methods: {
    onWrapperTouchStart: function onWrapperTouchStart() {
      this.touchStartTime = new Date();
    },
    onWrapperTouchEnd: function onWrapperTouchEnd(event) {
      var _this = this;
      // preventDefault(event);

      var deltaTime = new Date() - this.touchStartTime;
      var _ref = this.$refs.swipe || {},
        _ref$offsetX = _ref.offsetX,
        offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
        _ref$offsetY = _ref.offsetY,
        offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY;

      // prevent long tap to close component
      if (deltaTime < 300 && offsetX < 10 && offsetY < 10) {
        var _this$$refs, _this$$refs$swipe;
        if (!this.doubleClickTimer && (_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && (_this$$refs$swipe = _this$$refs.swipe) !== null && _this$$refs$swipe !== void 0 && _this$$refs$swipe.$children) {
          this.doubleClickTimer = setTimeout(function () {
            // 视频预览时，点击视频进行播放，点击非视频区域才进行关闭
            if ((_this.withMedia || _this.withVideo) && event.target !== _this.$refs.swipe.$children[_this.active].$el) {
              return;
            }
            _this.handleClose(event);
          }, 300);
        } else {
          clearTimeout(this.doubleClickTimer);
          this.doubleClickTimer = null;
          this.resetScale(this.scale > 1 ? 1 : 2);
        }
      }
    },
    startMove: function startMove(event) {
      if (this.$isServer) return;
      try {
        var image = event.currentTarget;
        var rect = image.getBoundingClientRect();
        var winWidth = window.innerWidth;
        var winHeight = window.innerHeight;
        this.touchStart(event);
        this.moving = true;
        this.startMoveX = this.moveX;
        this.startMoveY = this.moveY;
        this.maxMoveX = Math.max(0, (rect.width - winWidth) / 2);
        this.maxMoveY = Math.max(0, (rect.height - winHeight) / 2);
      } catch (error) {
        console.log(error);
      }
    },
    startZoom: function startZoom(event) {
      this.moving = false;
      this.zooming = true;
      this.startScale = this.scale;
      this.startDistance = getDistance(event);
    },
    onTouchStart: function onTouchStart(event) {
      var touches = event.touches;
      var _ref2 = this.$refs.swipe || {},
        _ref2$offsetX = _ref2.offsetX,
        offsetX = _ref2$offsetX === void 0 ? 0 : _ref2$offsetX;
      if (touches.length === 1 && this.scale !== 1) {
        this.startMove(event);
      } /* istanbul ignore else */else if (touches.length === 2 && !offsetX) {
        this.startZoom(event);
      }
    },
    onTouchMove: function onTouchMove(event) {
      var touches = event.touches;
      if (this.moving || this.zooming) {
        this.isTouch = true;
        (0, _event.preventDefault)(event, true);
      }
      if (this.moving) {
        this.touchMove(event);
        var moveX = this.deltaX + this.startMoveX;
        var moveY = this.deltaY + this.startMoveY;
        this.moveX = (0, _utils.range)(moveX, -this.maxMoveX, this.maxMoveX);
        this.moveY = (0, _utils.range)(moveY, -this.maxMoveY, this.maxMoveY);
      }
      if (this.zooming && touches.length === 2) {
        var distance = getDistance(event);
        var scale = this.startScale * distance / this.startDistance;
        this.scale = (0, _utils.range)(scale, MIN_ZOOM, MAX_ZOOM);
      }
    },
    onTouchEnd: function onTouchEnd(event) {
      /* istanbul ignore else */
      if (this.moving || this.zooming) {
        var stopPropagation = true;
        if (this.moving && this.startMoveX === this.moveX && this.startMoveY === this.moveY) {
          stopPropagation = false;
        }
        if (!event.touches.length) {
          this.moving = false;
          this.zooming = false;
          this.startMoveX = 0;
          this.startMoveY = 0;
          this.startScale = 1;
          if (this.scale < 1) {
            this.resetScale();
          }
        }
        if (stopPropagation) {
          (0, _event.preventDefault)(event, true);
        }
      }
    },
    onChange: function onChange(active) {
      this.resetScale();
      this.active = active;
      this.onChangeItem && this.onChangeItem(active);
    },
    resetScale: function resetScale(scale) {
      if (scale === void 0) {
        scale = 1;
      }
      this.scale = scale;
      this.moveX = 0;
      this.moveY = 0;
      this.isTouch = false;
    },
    handleClose: function handleClose(event) {
      var _this$images$index, _this$images$index2;
      event && event.stopPropagation();
      this.resetScale();
      this.loaded = {};
      var index = this.active;
      clearTimeout(this.doubleClickTimer);
      this.doubleClickTimer = null;
      this.$emit('close', {
        index: index,
        url: (_this$images$index = this.images[index]) !== null && _this$images$index !== void 0 && _this$images$index.videoUrl ? (_this$images$index2 = this.images[index]) === null || _this$images$index2 === void 0 ? void 0 : _this$images$index2.videoUrl : this.images[index],
        prises: this.goodsInfo && this.goodsInfo.prises || 0
      });
      if (!this.asyncClose) {
        this.$emit('input', false);
      }
    },
    handleScroll: function handleScroll(event) {
      event && event.stopPropagation();
    },
    handPriseClick: function handPriseClick(event) {
      event && event.stopPropagation();
      this.onClickPrise(true);
    },
    handCommentClick: function handCommentClick(event) {
      event && event.stopPropagation();
      this.onClickComment && this.onClickComment(true);
    },
    handLikeIconClick: function handLikeIconClick(event) {
      event && event.stopPropagation();
      this.onLikeIconClick && this.onLikeIconClick(this.expandTexts[this.active]);
    },
    handCommentIconClick: function handCommentIconClick(event) {
      event && event.stopPropagation();
      this.onCommentIconClick && this.onCommentIconClick(this.expandTexts[this.active]);
    },
    onLoaded: function onLoaded(e) {
      if (!this.showLoading) return;

      // 标记每一张图片的加载状态
      this.$set(this.loaded, e.target.src, true);
      // console.log(JSON.stringify(this.loaded))
    },
    onLoadError: function onLoadError(e) {
      this.onError && this.onError(e.target.src);
      this.onLoaded(e);
    }
  },
  render: function render(h) {
    var _this2 = this;
    if (!this.value) {
      return;
    }
    var active = this.active,
      images = this.images,
      texts = this.texts,
      _this$expandTexts = this.expandTexts,
      expandTexts = _this$expandTexts === void 0 ? [] : _this$expandTexts,
      isiPhoneX = this.isiPhoneX;
    var innerHeight = this.$isServer ? 0 : window.innerHeight;
    var innerWidth = this.$isServer ? 0 : window.innerWidth;
    var indexArr = [];
    var isShowBottomText = this.goodsInfo && Object.keys(this.goodsInfo).length > 0 ? true : false;
    var showBottomTexts = expandTexts.length;
    var _ref3 = this.goodsInfo || {},
      title = _ref3.title,
      label = _ref3.label,
      desc = _ref3.desc,
      prises = _ref3.prises,
      comments = _ref3.comments,
      like = _ref3.like;
    if (this.adaptHeight) {
      images.forEach(function (item, index) {
        var h = (0, _utils.getParam)(item, 'h');
        var w = (0, _utils.getParam)(item, 'w');
        if (h && w && h > innerHeight && h > innerHeight / innerWidth * w) {
          indexArr.push(index);
        }
      });
    }
    var Close = this.showClose && h(_icon.default, {
      "class": [bem('close'), isShowBottomText || showBottomTexts ? 'b2c_close' : ''],
      "attrs": {
        "name": isShowBottomText || showBottomTexts ? 'cross' : 'clear'
      },
      "on": {
        "touchend": this.handleClose,
        "mouseup": this.handleClose
      }
    });
    var Index = this.showIndex && h("div", {
      "class": [bem('index'), isShowBottomText || showBottomTexts ? 'b2c_index' : '']
    }, [active + 1 + "/" + images.length]);
    var Images = h(_swipeNew.default, {
      "ref": "swipe",
      "attrs": {
        "loop": this.loop,
        "indicatorColor": "white",
        "initialSwipe": this.startPosition,
        "showIndicators": this.showIndicators,
        "adaptHeight": this.adaptHeight,
        "lazy-render": true
      },
      "on": {
        "change": this.onChange
      }
    }, [images.map(function (image, index) {
      var props = {
        class: indexArr.includes(index) ? 'z-image-preview__image--adapt' : 'z-image-preview__image',
        style: index === active ? _this2.imageStyle : null,
        on: {
          touchstart: _this2.onTouchStart,
          touchmove: _this2.onTouchMove,
          touchend: _this2.onTouchEnd,
          touchcancel: _this2.onTouchEnd,
          load: _this2.onLoaded,
          error: _this2.onLoadError
        }
      };
      if (image.videoUrl) {
        return h(_swipeItemNew.default, [h(_bizVideo.default, {
          "attrs": {
            "video-url": image.videoUrl,
            "pic-url": image.picUrl,
            "auto": image.auto,
            "controls": image.controls,
            "px2rem": image.px2rem || true,
            "fullScreen": image.fullScreen,
            "muteBtn": image.muteBtn,
            "showPlay": image.showPlay,
            "width": image.width || '700',
            "height": image.height || '700'
          }
        })]);
      }
      return h(_swipeItemNew.default, {
        "attrs": {
          "adaptHeightItem": indexArr.includes(index)
        },
        "class": bem('swipe-item')
      }, [_this2.lazyLoad ? h("img", (0, _babelHelperVueJsxMergeProps.default)([{
        "directives": [{
          name: "lazy",
          value: (0, _zzUtils.setPicSize)(image)
        }]
      }, props])) : h("img", (0, _babelHelperVueJsxMergeProps.default)([{
        "attrs": {
          "src": (0, _zzUtils.setPicSize)(image)
        }
      }, props])), _this2.showLoading && !_this2.loaded[image] && h(_loading.default, {
        "attrs": {
          "type": _this2.loadingType
        }
      }), texts && texts[index] && h("div", {
        "class": [bem('texts'), isiPhoneX ? 'z-iphone-x' : '']
      }, [h("span", [texts[index]])])]);
    })]);
    var BottomText = isShowBottomText && !this.isTouch && h("div", {
      "class": [bem('bottom_text'), isiPhoneX ? 'z-iphone-x' : ''],
      "on": {
        "touchend": this.handleScroll,
        "mouseup": this.handleScroll
      }
    }, [h("div", {
      "class": "bottom_wrapper"
    }, [h("span", {
      "class": "title"
    }, [title]), label && h("div", {
      "class": "tag"
    }, [label.map(function (item) {
      return h("span", {
        "class": "tag-item"
      }, [item]);
    })]), h("div", {
      "class": "text"
    }, [desc])])]);
    var userPrise = isShowBottomText && h("div", {
      "class": [bem('user_prise')]
    }, [h("div", {
      "class": "icon",
      "on": {
        "touchend": this.handPriseClick
      }
    }, [like ? h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)('455b6ded-6113-49dd-b416-629f3c63a38f.png')
      }
    }) : h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)('916e05bc-39ca-4745-8590-c62582da5857.png')
      }
    }), h("span", {
      "class": "text"
    }, [prises > 0 ? prises : '有用'])]), h("div", {
      "class": "icon",
      "on": {
        "touchend": this.handCommentClick
      }
    }, [h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)('36ce6cfc-041c-4c01-9275-459c35942515.png')
      }
    }), h("span", {
      "class": "text"
    }, [comments > 0 ? comments : '评论'])])]);
    return h("transition", {
      "attrs": {
        "name": "z-fade"
      }
    }, [h("div", {
      "class": [bem(), this.className, isiPhoneX && bem('iphone-x')],
      "on": {
        "touchstart": this.onWrapperTouchStart,
        "touchend": this.onWrapperTouchEnd,
        "touchcancel": this.onWrapperTouchEnd
      }
    }, [Close, Index, Images, BottomText, userPrise, expandTexts.length && !this.isTouch && h("div", {
      "class": [bem('bottom_text'), isiPhoneX ? 'z-iphone-x' : ''],
      "on": {
        "touchend": this.handleScroll,
        "mouseup": this.handleScroll
      }
    }, [h("div", {
      "class": "bottom_wrapper"
    }, [h("span", {
      "class": "title_wrapper"
    }, [expandTexts[this.active].rate && h(_rate.default, {
      "attrs": {
        "value": expandTexts[this.active].rate,
        "size": 9,
        "color": "#FFBE22",
        "void-color": "rgba(255, 255, 255, 0.6)"
      }
    }), expandTexts[this.active].rate && h("span", {
      "class": "divider"
    }), h("span", {
      "class": "title"
    }, [expandTexts[this.active].title])]), expandTexts[this.active].label && h("div", {
      "class": "tag"
    }, [expandTexts[this.active].label.map(function (item) {
      return h("span", {
        "class": "tag-item"
      }, [item]);
    })]), h("div", {
      "class": "text"
    }, [expandTexts[this.active].desc])])]), expandTexts.length && h("div", {
      "class": [bem('user_prise')]
    }, [h("div", {
      "class": "icon",
      "on": {
        "touchend": this.handLikeIconClick
      }
    }, [expandTexts[this.active].liked ? h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)(expandTexts[this.active].likeIcon || '455b6ded-6113-49dd-b416-629f3c63a38f.png')
      }
    }) : h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)(expandTexts[this.active].unLikeIcon || '916e05bc-39ca-4745-8590-c62582da5857.png')
      }
    }), h("span", {
      "class": "text"
    }, [expandTexts[this.active].likeCount > 0 ? expandTexts[this.active].likeCount : expandTexts[this.active].likeText || '点赞'])]), h("div", {
      "class": "icon",
      "on": {
        "touchend": this.handCommentIconClick
      }
    }, [h("img", {
      "attrs": {
        "src": (0, _zzUtils.setPicSize)(expandTexts[this.active].commentIcon || '36ce6cfc-041c-4c01-9275-459c35942515.png')
      }
    }), h("span", {
      "class": "text"
    }, [expandTexts[this.active].commentCount > 0 ? expandTexts[this.active].commentCount : expandTexts[this.active].commentText || '评论'])])])])]);
  }
});
exports.default = _default2;